import { defineStore } from 'pinia';
import api from '@/services/api';
import order_import_model from '../models/order_import_model';
import order_import_filters_model from '../models/order_import_filters_model';
import { useWorkOrderStore } from '@/views/work_orders/stores/work_order_store';

import { getParamsUrl } from '../order_import_utils';

export const useOrderImportStore = defineStore('orderImportStore', {
  state: () => ({
    entity: 'importacion-pedidos',
    pedido: JSON.parse(JSON.stringify(order_import_model)),
    filters: { ...order_import_filters_model },
    pedidos: [],
    page: 1,
    selectedItems: [],
    codigoElementoGrupoSelected: null,
  }),
  getters: {
    flowAction: (state) => (route) => {
      if (route?.name === 'workOrderEdit') {
        const workOrderStore = useWorkOrderStore();
        const etAsignadas = workOrderStore.getEtAsignadasFromRoute(route);

        return 'import';
      }
      return 'generate';
    },
    etPedidoSeleccionadas: (state) => () => {
      return state.selectedItems.map((item) => item.EspecificacionTecnica?.Codigo);
    },
  },
  actions: {
    async findAllOrderImportHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ ...this.filters, page: +this.page, ...params })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.pedidos.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async firstOrderImport() {
      this.setPage(1);
      this.emptyList();
      this.resetFilter();
      await this.findAllOrderImportHTTP();
    },
    emptyList() {
      this.pedidos = [];
    },
    setFilters(newFilters) {
      console.log(newFilters);
      this.filters = { ...newFilters };
    },
    setPage(page) {
      this.page = page;
    },
    resetFilter() {
      this.filters = { ...order_import_filters_model };
    },
    checkSelected(item) {
      if (item.Event === 'add') {
        this.selectedItems.push(item);
        if (!this.codigoElementoGrupoSelected) {
          this.codigoElementoGrupoSelected = item.codigoElementoGrupo;
        }
      } else if (item.Event === 'remove') {
        this.selectedItems = this.selectedItems.filter(
          (i) => i.codigoCantidad !== item.codigoCantidad,
        );
        if (this.selectedItems.length === 0) {
          this.codigoElementoGrupoSelected = null;
        }
      }
    },
    setSelectedItems(items) {
      this.selectedItems = items;
      if (this.selectedItems.length === 0) {
        this.codigoElementoGrupoSelected = null;
      }
    },
    clearSelectedItems() {
      this.selectedItems = [];
      this.codigoElementoGrupoSelected = null;
    },
  },
});
